/**
 *
 * Asynchronously loads the component for ProfileCompletionInterestPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ProfileCompletionInterestPage = lazyLoad(
  () => import('./index'),
  module => module.ProfileCompletionInterestPage,
);
